import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../constants/apiConstants';
import axiosInstance from '../api/axios';

const initialState: any = {
  kitchenIndent: [],
  mogsData: [],
  aplsData: [],
  loading: false,
  error: null,
};


export const fetchKitchenIndent = createAsyncThunk(
  'kitchenIndentProductionPlan/fetchKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/GetKitchenIndentProductionPlan`, payload);
    return response?.data?.data?.kitchensectionlist;
  }
);

export const fetchUpdateRequisitionDataIntoKIPP = createAsyncThunk(
  'kitchenIndentProductionPlan/UpdateRequisitionDataIntoKIPP',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/UpdateRequisitionDataIntoKIPP`, payload);
    return response?.data?.data?.kitchensectionlist;
  }
);

export const saveKitchenIndent = createAsyncThunk(
  'kitchenIndentProductionPlan/saveKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/UpdateMOGKitchenIndentProductionPlan`, payload);
    return response?.data;
  }
);

export const submitKitchenIndent = createAsyncThunk(
  'kitchenIndentProductionPlan/submitKitchenIndent',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/SubmitKitchenIndentProductionPlan`, payload);
    return response?.data;
  }
);

export const fetchMogs = createAsyncThunk(
  'kitchenIndent/fetchMogs',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/GetMOG`, payload);
    return response?.data?.data?.mogs;
  }
);

export const fetchApls = createAsyncThunk(
  'kitchenIndent/fetchApls',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndent/GetAPL`, payload);
    return response?.data?.data?.apls;
  }
);

export const addMog = createAsyncThunk(
  'kitchenIndentProductionPlan/addMog',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/AddMOGKitchenIndentProductionPlan`, payload);
    return response?.data;
  }
);

export const removeMog = createAsyncThunk(
  'kitchenIndentProductionPlan/removeMog',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/DeleteMOGKitchenIndentProductionPlan`, payload);
    return response?.data;
  }
);

export const fetchCutOfTime = createAsyncThunk(
  'kitchenIndentProductionPlan/fetchCutOfTime',
  async (payload: object) => {
    const response: any = await axiosInstance.post(`${BASE_URL}/api/v1/KitchenIndentProductionPlan/GetCutoffDateTime`, payload);
    return response?.data?.data;
  }
);

const kitchenIndentProductionPlanSlice = createSlice({
  name: 'KitchenIndentProductionPlan',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchKitchenIndent.fulfilled, (state, action) => {
        // state.loading = false;
        state.kitchenIndent = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchKitchenIndent.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.error.message;
      });
       builder
      .addCase(fetchUpdateRequisitionDataIntoKIPP.fulfilled, (state, action) => {
        // state.loading = false;
        state.kitchenIndent = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchUpdateRequisitionDataIntoKIPP.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.error.message;
      });
    builder
      .addCase(fetchMogs.fulfilled, (state, action) => {

        state.mogsData = action.payload; // Assuming the payload is an array of menu plans
      })
      .addCase(fetchMogs.rejected, (state, action) => {
        state.error = action.error.message;
      });
    // builder
    //   .addCase(saveKitchenIndent.pending, (state) => {
    //     state.loading = true;
    //   })
    //   .addCase(saveKitchenIndent.fulfilled, (state, action) => {
    //     state.loading = false;
    //     state.kitchenIndent = action.payload?.data?.kitchensectionlist; // Assuming the payload is an array of menu plans
    //   })
    //   .addCase(saveKitchenIndent.rejected, (state, action) => {
    //     state.loading = false;
    //     state.error = action.error.message;
    //   });
  },
});

export default kitchenIndentProductionPlanSlice.reducer;
